/* Product text script conversion. OpenCC dictionaries are self-hosted theme assets. */
(() => {
  'use strict';
  const locale = document.documentElement.lang.toLowerCase();
  const simplified = /^(zh-cn|zh-hans)(-|$)/.test(locale);
  const traditional = /^(zh-tw|zh-hant|zh-hk)(-|$)/.test(locale);
  if ((!simplified && !traditional) || !window.OpenCC || document.documentElement.dataset.veHanReady) return;
  const convert = window.OpenCC.Converter(simplified ? {from:'tw', to:'cn'} : {from:'cn', to:'tw'});
  const han = /[\u3400-\u9fff\uf900-\ufaff]/;
  const scope = '[data-ve-han],.breadcrumb,.art-column,.buy-column,.story,.record-section,.track-section,.mobile-buy,.product,.ve-rsd-slide,.ve-rsd-pick,.editor-text,.ve-soundtrack-pair,.card__heading,.product-card,.cart-item__name';
  const exclude = 'script,style,noscript,template,textarea,input,code,pre,svg,math,[contenteditable="true"],[translate="no"],.notranslate,[data-ve-han-ignore],[lang="ja"],[lang="en"],.language-panel';
  const attributes = ['alt', 'title', 'aria-label', 'data-image-alt'];
  const cache = new Map();
  const text = value => {
    if (!value || !han.test(value)) return value;
    if (cache.has(value)) return cache.get(value);
    const output = convert(value);
    if (cache.size > 2000) cache.clear();
    cache.set(value, output);
    cache.set(output, output);
    return output;
  };
  const apply = root => {
    if (!root || root.closest(exclude)) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: node => node.parentElement && !node.parentElement.closest(exclude) && han.test(node.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT
    });
    let node;
    while ((node = walker.nextNode())) {
      const value = text(node.nodeValue);
      if (value !== node.nodeValue) node.nodeValue = value;
    }
    const elements = [root, ...root.querySelectorAll('[alt],[title],[aria-label],[data-image-alt]')];
    for (const element of elements) {
      if (element.closest(exclude)) continue;
      for (const name of attributes) {
        const original = element.getAttribute(name);
        const value = text(original);
        if (value !== original) element.setAttribute(name, value);
      }
    }
  };
  const start = () => {
    const pending = new Set();
    let queued = false;
    const options = {subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:attributes};
    const observer = new MutationObserver(mutations => {
      for (const mutation of mutations) {
        const target = mutation.target.nodeType === Node.ELEMENT_NODE ? mutation.target : mutation.target.parentElement;
        const parent = target?.closest(scope);
        if (parent) pending.add(parent);
        for (const node of mutation.addedNodes || []) {
          if (node.nodeType !== Node.ELEMENT_NODE) continue;
          if (node.matches(scope)) pending.add(node);
          node.querySelectorAll(scope).forEach(element => pending.add(element));
        }
      }
      if (!pending.size || queued) return;
      queued = true;
      queueMicrotask(() => {
        queued = false;
        observer.disconnect();
        for (const element of pending) if (element.isConnected) apply(element);
        pending.clear();
        observer.observe(document.body, options);
      });
    });
    document.querySelectorAll(scope).forEach(element => {
      if (!element.parentElement?.closest(scope)) apply(element);
    });
    document.title = text(document.title);
    document.documentElement.dataset.veHanReady = simplified ? 'zh-CN' : 'zh-TW';
    observer.observe(document.body, options);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
